import React from "react";
import PublicPageLayout from "./PublicPageLayout";
import ResearchPublicationsContent from "../Common/ResearchPublicationsContent";

/**
 * PublicResearchPublications - Research Publications page wrapper for public/unauthenticated users
 * Uses PublicPageLayout for header/footer and ResearchPublicationsContent for the actual content
 */
const PublicResearchPublications = () => {
    return (
        <PublicPageLayout>
            <ResearchPublicationsContent />
        </PublicPageLayout>
    );
};

export default PublicResearchPublications;
